let marker = document.querySelector("#marker2");
let tabItem = document.querySelectorAll(".box8-tab a");
let tabItemContent = document.querySelectorAll(".box8-tab-c-item");
const box2_video = document.querySelector('#box2-video');
const box5_video = document.querySelector('#box5-video');
const box6_video = document.querySelector('#box6-video');
const box7TabImg = document.querySelectorAll(".box7-b .left picture");
const box7TabItem = document.querySelectorAll(".box7-b .right .right-li");
const box11_video1 = document.querySelector('#box11-1-video')
const box11_video2 = document.querySelector('#box11-2-video')
const box11List = document.querySelectorAll(".box11-info .l ul li");


ScrollTrigger.create({
  trigger: '.box6',
  start: 'top bottom',
  scrub: true,
  once: true,
  onEnter(){
    box6_video.load();
  },
})

ScrollTrigger.create({
  trigger: '.box6-bottom',
  start: 'top 70%',
  scrub: true,
  once: true,
  onEnter(){
    const playPromise = box6_video.play();
    if (playPromise !== undefined) {
      playPromise.then(() => {

        box6_video.onended = () => {

        };

      }).catch(error => {

      });
    }

  }
})

ScrollTrigger.create({
  trigger: '.box7 .container',
  start: 'top +=13%',
  end: '200%',
  scrub: true,
  pin:true,
  onUpdate(self){
    let listIndex = Math.ceil(self.progress * 3) - 1;
    if (listIndex < 0) listIndex = 0
  
    box7TabImg.forEach(item => {
      item.classList.remove("active");
    })
    box7TabItem.forEach(item => {
      item.classList.remove("active");
    })

    box7TabItem[listIndex].classList.add("active");
    box7TabImg[listIndex].classList.add("active");
    

  }
})

ScrollTrigger.create({
  trigger: '.box6-bottom',
  start: 'center 70%',
  scrub: true,
  once: true,
  onEnter(){
    const box6_bottom_text = document.querySelector(".box6-bottom .bottom-text");
    box6_bottom_text.classList.add('active');
  }
})


ScrollTrigger.matchMedia({
  "(min-width: 750px)": function() {

    setResponsiveVideoSource(box2_video, {
      url: [
        { src: "https://cdn.shopify.com/videos/c/o/v/8e2cc41366744f978f886ac8ca515d71.mp4", type: "video/mp4" }
      ]
    });
    setResponsiveVideoSource(box5_video, {
      url: [
        { src: "https://cdn.shopify.com/videos/c/o/v/86ef06628fbc4f079c853e483f49f10e.mp4", type: "video/mp4" }
      ]
    });
    setResponsiveVideoSource(box6_video, {
      url: [
        { src: "http://www.boox.com/wp-content/uploads/2025/04/07.mov", type: "video/quicktime" },
        { src: "https://cdn.shopify.com/videos/c/o/v/1189a57a75f546d6975fbfad88177e5b.webm", type: "video/webm" },
        { src: "https://cdn.shopify.com/videos/c/o/v/2dba76d24d1a47ca93f3ffe07f97bd22.mp4", type: "video/mp4" }
      ]
    });

  },
  "(max-width: 750px)": function() {

    setResponsiveVideoSource(box2_video, {
      url: [
        { src: "https://cdn.shopify.com/videos/c/o/v/8d68a2cbfd8243df96564e304e7dfc46.mp4", type: "video/mp4" }
      ]
    });
    setResponsiveVideoSource(box5_video, {
      url: [
        { src: "https://cdn.shopify.com/videos/c/o/v/e807b4cbb36746a5820431b930742c78.mp4", type: "video/mp4" }
      ]
    });
    setResponsiveVideoSource(box6_video, {
      url: [
        { src: "https://cdn.shopify.com/videos/c/o/v/05278aa8b4a94a9f9ae39f0b4d86c18b.mp4", type: "video/mp4" }
      ]
    });
  }
})


function indicator(e){
  marker.style.left = e.offsetLeft + 'px';
  marker.style.width = e.offsetWidth + 'px';
}

tabItem.forEach((link,index) => {
  
  link.addEventListener('mouseover', (e)=>{
    indicator(e.target)

    tabItemContent.forEach(item => {
      item.classList.remove("box8-active");
    })
    tabItem.forEach(item => {
      item.classList.remove("box8-tab-active");
    })

    tabItem[index].classList.add("box8-tab-active");
    tabItemContent[index].classList.add("box8-active");
    box8_splide.go(index);
  })

  link.addEventListener('click', (e)=>{
    indicator(e.target)

    tabItemContent.forEach(item => {
      item.classList.remove("box8-active");
    })
    tabItem.forEach(item => {
      item.classList.remove("box8-tab-active");
    })

    tabItem[index].classList.add("box8-tab-active");
    tabItemContent[index].classList.add("box8-active");
    box8_splide.go(index);
  })

})

// 切换视频
function setResponsiveVideoSource(videoElement, options) {
  if (!videoElement) return;
  const sources = options.url;
  // 清除旧的 source 标签
  while (videoElement.firstChild) {
    videoElement.removeChild(videoElement.firstChild);
  }

  // 添加新的 source
  sources.forEach(sourceInfo => {
    const source = document.createElement('source');
    source.src = sourceInfo.src;
    source.type = sourceInfo.type;
    videoElement.appendChild(source);
  });

  videoElement.load();
}

function click_video_anime(index){
  
  const video = document.querySelectorAll('#box11-splide .splide__slide .bg  .item-video')
  const img = document.querySelectorAll('#box11-splide .splide__slide .bg picture')

  video.forEach((item) => item.classList.remove('active'));
  img.forEach((item) => item.classList.remove('active'));

  box11_video1.currentTime = 0;
  box11_video2.currentTime = 0;
  box11_video1.pause();
  box11_video2.pause();

  if(index === 1){

    let playPromise1 = box11_video1.play();

    if (playPromise1 !== undefined) {
      playPromise1.then(_ => {
        box11_video1.addEventListener('ended', () => {
          video[index-1].classList.add('active');
          img[index].classList.add('active');
        });

      })
      .catch(error => {
        console.log(error)
      });
    }
    
  }

  if(index === 2){

    let playPromise2 = box11_video2.play();
    if (playPromise2 !== undefined) {
      playPromise2.then(_ => {
        box11_video2.addEventListener('ended', () => {
          video[index-1].classList.add('active');
          img[index].classList.add('active');
        });

      })
      .catch(error => {
        console.log(error)
      });
    }

  }

}

const box8_splide =  new Splide('#box8-splide', {
  perPage: 1,
  arrows: true,
  drag: false,
  pagination: false,
  focus  : 'center',
  speed: 0,
  breakpoints: {
    750: {
      arrows: false
    }
  }
}).mount(); 

box8_splide.on('move', () => {
  const activeIndex = box8_splide.index;

  indicator(tabItem[activeIndex])

  tabItemContent.forEach(item => {
    item.classList.remove("box8-active");
  })
  tabItem.forEach(item => {
    item.classList.remove("box8-tab-active");
  })

  tabItem[activeIndex].classList.add("box8-tab-active");
  tabItemContent[activeIndex].classList.add("box8-active");
});

const box11_splide =  new Splide('#box11-splide', {
  perPage: 1,
  arrows: false,
  drag: false,
  focus  : 'center',
  speed: 0
}).mount(); 

box11List.forEach((slide, index) => {
  slide.addEventListener('click', () => {
    box11List.forEach(item => {
      item.classList.remove("active");
    })
    box11List[index].classList.add("active");
    box11_splide.go(index); // 切换到点击的 Slide
    click_video_anime(index)
  });
});

box11_splide.on('move', () => {
  const activeIndex = box11_splide.index;
  box11List.forEach(item => {
    item.classList.remove("active");
  })
  box11List[activeIndex].classList.add("active");
  click_video_anime(activeIndex)
});

$(function() {
const box5 = document.querySelector(".box5");
const box6 = document.querySelector(".box6");
const box7 = document.querySelector(".box7");
const box10 = document.querySelector(".box10");
const box12 = document.querySelector(".box12");

const skip1 =  document.querySelector(".box3-parameters .box-l .item1");
const skip2 =  document.querySelector(".box3-parameters .box-l .item2");
const skip3 =  document.querySelector(".box3-parameters .box-l .item3");
const skip4 =  document.querySelector(".box3-parameters .box-r .item2");
const skip5 =  document.querySelector(".box3-parameters .box-r .item3");

const proHeaderHeight = document.querySelector(".product-specs__header").offsetHeight;

// 点击滚到到元素位置
function distanceToTop(clickEl,GoEl,Extension = 0){
  clickEl.addEventListener('click',()=>{
    
    let distanceToTop  = GoEl
    if(Extension){
      distanceToTop-=Extension
    }
    
    window.scrollTo({top:distanceToTop})
    // window.scrollTo({top:distanceToTop,behavior: "smooth"})
  })
}
distanceToTop(skip1,box5.offsetTop,proHeaderHeight);
distanceToTop(skip2,box6.offsetTop,proHeaderHeight);
distanceToTop(skip3,box7.offsetTop,proHeaderHeight);
distanceToTop(skip4,box10.offsetTop,proHeaderHeight);
distanceToTop(skip5,box12.offsetTop,proHeaderHeight);
})